module.exports = __webpack_public_path__ + "img/gzh.34a48c02.jpg";